<div class="ts1-rating-step2-v2">
	<div class="ts1-rating-step2-v2__body">
		<app-ts1-rating-maneuver-sidebar
			[maneuvers]="maneuvers"
			[maneuverCodes]="maneuverCodes"
			[maneuverOutcomes]="maneuverOutcomes"
			[hasSecondCandidate]="hasSecondCandidate"
			[activeIndex]="activeManeuverIndex"
			(activeIndexChange)="onManeuverSelect($event)"
		></app-ts1-rating-maneuver-sidebar>

		<div class="ts1-rating-step2-v2__main">
			@if (loaded) {
				<div
					class="ts1-rating-step2-v2__columns-header"
					[class.ts1-rating-step2-v2__columns-header--reversed]="leftCandidateRole === CandidateRole.PM"
				>
					<div class="ts1-rating-step2-v2__col-header ts1-rating-step2-v2__col-header--left">
						<div class="ts1-rating-step2-v2__col-header-row">
							<span class="ts1-rating-step2-v2__candidate-name">{{ leftCandidateName }}</span>
							<span
								class="ts1-role-badge"
								[class.ts1-role-badge--pf]="leftCandidateRole === CandidateRole.PF"
								[class.ts1-role-badge--pm]="leftCandidateRole === CandidateRole.PM"
								>{{ leftRoleLabel }}</span
							>
						</div>
					</div>
					@if (canSwapRoles) {
						<button
							type="button"
							class="ts1-rating-step2-v2__swap"
							[class.ts1-rating-step2-v2__swap--reversed]="leftCandidateRole === CandidateRole.PM"
							(click)="onSwapRoles()"
							matTooltip="Swap PF/PM"
							aria-label="Swap PF/PM roles"
						>
							<svg
								class="ts1-rating-step2-v2__swap-icon"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								aria-hidden="true"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M7.00003 10.75C6.6874 10.75 6.40756 10.5561 6.29779 10.2634C6.18801 9.97062 6.27134 9.64051 6.50688 9.43494L9.94438 6.43494C10.2565 6.16258 10.7302 6.19478 11.0026 6.50686C11.275 6.81894 11.2428 7.29272 10.9307 7.56508L9.00003 9.25001H17C17.4142 9.25001 17.75 9.58579 17.75 10C17.75 10.4142 17.4142 10.75 17 10.75H7.00003Z"
									fill="currentColor"
								/>
								<path
									d="M13.0694 16.4349C12.7573 16.7073 12.7251 17.1811 12.9975 17.4932C13.2698 17.8052 13.7436 17.8374 14.0557 17.5651L17.4932 14.5651C17.7287 14.3595 17.8121 14.0294 17.7023 13.7367C17.5925 13.4439 17.3127 13.25 17 13.25H7C6.58579 13.25 6.25 13.5858 6.25 14C6.25 14.4142 6.58579 14.75 7 14.75H15L13.0694 16.4349Z"
									fill="currentColor"
								/>
							</svg>
						</button>
					}
					<div
						class="ts1-rating-step2-v2__col-header ts1-rating-step2-v2__col-header--right"
						[class.ts1-rating-step2-v2__col-header--disabled]="!hasSecondCandidate"
					>
						<div class="ts1-rating-step2-v2__col-header-row">
							<span class="ts1-rating-step2-v2__candidate-name">{{ rightCandidateName }}</span>
							<span
								class="ts1-role-badge"
								[class.ts1-role-badge--pf]="rightCandidateRole === CandidateRole.PF"
								[class.ts1-role-badge--pm]="rightCandidateRole === CandidateRole.PM"
								>{{ rightRoleLabel }}</span
							>
						</div>
					</div>
				</div>

				<div class="ts1-rating-step2-v2__obs-content">
					@for (panelKey of obPanelKeys; track panelKey) {
						<app-ts1-rating-ob-panel
							#obPanelRef
							[leftManeuverForm]="leftManeuverForm"
							[rightManeuverForm]="rightManeuverForm"
							[leftSlot]="leftObSlot"
							[rightSlot]="rightObSlot"
							[leftCandidateRole]="leftCandidateRole"
							[rightCandidateRole]="rightCandidateRole"
							[leftCandidateName]="leftCandidateName"
							[rightCandidateName]="rightCandidateName"
							[leftColumnEnabled]="!!leftManeuverForm"
							[rightColumnEnabled]="!!rightManeuverForm"
							[hasSecondCandidate]="hasSecondCandidate"
							[activeManeuverOutcome]="activeOutcome"
							[assessmentConfig]="assessmentConfig"
							[obCommentsEnabled]="obCommentsEnabled"
							[showConditionalObHighlight]="showConditionalObHighlight"
							(obComment)="onObComment($event)"
							(repeatApplied)="onManeuverRepeated($event)"
						></app-ts1-rating-ob-panel>
					}

					@if (activeOutcome) {
						<app-ts1-rating-maneuver-outcome
							[maneuverLabel]="activeManeuverLabel"
							[pfCandidateId]="pfCandidateId"
							[pmCandidateId]="pmCandidateId"
							[leftCandidateId]="leftCandidateId"
							[rightCandidateId]="rightCandidateId"
							[pmCandidateName]="pmCandidateName"
							[pfCandidateName]="pfCandidateName"
							[candidateCrewRoles]="candidateCrewRoles"
							[hasSecondCandidate]="hasSecondCandidate"
							[outcome]="activeOutcome"
							(outcomeChange)="onOutcomeChange($event)"
							(outcomeComment)="onOutcomeComment($event)"
						></app-ts1-rating-maneuver-outcome>
					}
				</div>
			}
		</div>
	</div>

	<div class="mb-6 mt-5 flex h-[40px] items-center justify-start bg-blue-20 px-4 text-lg font-medium text-black">
		Instructor Notes/Comments
	</div>
	<div class="ts1-rating-step2-v2__notes mb-8 flex flex-col gap-8 p-4">
		<div>
			<p class="text-sm text-grey-60">Instructor Comments & Observation</p>
			<div
				class="border-1 flex h-[150px] flex-col items-stretch justify-stretch rounded border border-[#CFE3FF] text-[85%] uppercase"
			>
				<div class="flex-1 overflow-y-auto overflow-x-hidden p-3">
					@if (displayObComments.length === 0) {
						<span class="text-grey-40">No summary comments.</span>
					} @else {
						<div class="ts1-summary-list">
							@for (comment of displayObComments; track $index) {
								<div class="ts1-summary-row">
									<span class="ts1-summary-row__segment ts1-summary-row__segment--candidate">
										@if (comment?.ob !== "REPEAT" || getCommentCandidateLabel(comment)) {
											[
											@if (getCommentCandidateLabel(comment); as candidateLabel) {
												<span [class]="getCommentCandidateLabelClass(comment)">{{ candidateLabel }}</span>
											}
											@if (
												comment?.ob !== "REPEAT" &&
												getCommentCandidateLabel(comment) &&
												(comment.candidateRole === CANDIDATE_ROLE.PF || comment.candidateRole === CANDIDATE_ROLE.PM)
											) {
												<span class="text-grey-60"> · </span>
											}
											@if (comment?.ob !== "REPEAT" && comment.candidateRole === CANDIDATE_ROLE.PF) {
												<span class="text-purple-90">PF</span>
											}
											@if (comment?.ob !== "REPEAT" && comment.candidateRole === CANDIDATE_ROLE.PM) {
												<span class="text-purple-90">PM</span>
											}
											]
										}
									</span>
									<span class="ts1-summary-row__segment ts1-summary-row__segment--maneuver">
										@if (!comment?.isTemCompetencyOutcome) {
											{{ summaryManeuverLabel(comment) }}
										}
									</span>
									<span class="ts1-summary-row__segment ts1-summary-row__segment--status">
										@if (comment?.isObservationComment) {
											<span>{{ comment?.ob }}</span>
										} @else if (comment?.isManeuverOutcome) {
											@if (comment?.remarks) {
												<span [class]="getOutcomeRateClass(comment.rate)">{{ comment.remarks }}</span>
											}
										} @else if (comment?.isTemCompetencyOutcome) {
											<span class="text-teal">{{ temSafetyOutcomeLabel }}</span>
											@if (comment?.remarks) {
												<span [class]="getOutcomeRateClass(comment.rate)">{{ " { " + comment.remarks + " }" }}</span>
											}
										} @else if (comment?.ob !== "TEM" && comment?.ob !== "REPEAT") {
											@if (comment?.isReset || comment?.lastActionDisabled || comment?.isDisabled) {
												<span class="text-yellow">{{ comment?.ob }}</span>
											} @else {
												<span [class.text-green]="comment?.action" [class.text-red]="!comment?.action">
													{{ comment?.ob }}
												</span>
											}
											@if (comment?.isReset) {
												<span class="text-yellow">{{ " { Undo }" }}</span>
											} @else if (comment?.lastActionDisabled) {
												<span class="text-yellow">{{ " { Undo N/A }" }}</span>
											} @else if (comment?.isDisabled) {
												<span class="text-yellow">{{ " { N/A }" }}</span>
											} @else if (comment?.action != null) {
												<span [class.text-green]="comment?.action" [class.text-red]="!comment?.action">
													{{ comment?.action ? " { added }" : " { removed }" }}
												</span>
											}
										}
										@if (comment?.ob === "REPEAT") {
											<span class="text-yellow">{{ comment?.ob }}</span>
										}
									</span>
									<span class="ts1-summary-row__segment ts1-summary-row__segment--comment normal-case">
										@if (hasInstructorComment(comment)) {
											{{ comment.instructorComment }}
										} @else if (isMissingRequiredComment(comment)) {
											<span class="ts1-summary-missing-comment-badge">
												<mat-icon class="ts1-summary-missing-comment-badge__icon" aria-hidden="true">
													error_outline
												</mat-icon>
												<span>Comment required</span>
											</span>
										}
									</span>
								</div>
							}
						</div>
					}
				</div>
				<div class="flex items-center justify-end px-3 pb-3">
					<button
						(click)="viewSummaryModal()"
						class="size-6 rounded-sm bg-red pt-1 text-center text-white lg:size-8"
						matTooltip="View/Edit Comments"
						type="button"
					>
						<mat-icon class="text-xs lg:text-base">edit</mat-icon>
					</button>
				</div>
			</div>
		</div>
	</div>
</div>
